module.exports = __webpack_public_path__ + "static/media/DNP3.9e4a8c57.jpg";